if (!customElements.get('default-infinite-scroll')) {
  customElements.define(
    'default-infinite-scroll',
    class DefaultInfiniteScroll extends HTMLElement {
      constructor() {
        super();
        this.pages = Number(this.getAttribute('data-pages'));
        this.page = Number(this.getAttribute('data-current-page'));
        this.containerSelector = this.getAttribute('data-container');
        this.button = this.querySelector('.load-more-button');
        this.loadMoreText = this.getAttribute('data-load-more-text');
        this.loadingText = this.getAttribute('data-loading-text');
        this.nextPageLinkSelector = '.default-pagination__wrapper .next a';
        this.nextPageLink = this.querySelector(this.nextPageLinkSelector);
      }

      connectedCallback() {
        if (this.button) {
          this.button.style.display = '';
          this.button.addEventListener('click', () => this.loadMoreProducts());
        }
        this.updateButtonVisibility();
      }

      updateButtonVisibility() {
        const nextLink = document.querySelector('.default-pagination__wrapper .next a');

        if (this.page >= this.pages || !nextLink) {
          if (this.button) {
            this.button.style.display = 'none';
          }
        } else {
          if (this.button) {
            this.button.style.display = 'block';
          }
        }
      }

      async loadMoreProducts() {
        if (!this.nextPageLink || this.page >= this.pages) return;

        const url = this.nextPageLink.href; // Use the next link's URL
        console.log(this.page);
        this.page += 1;

        this.setAttribute('loading', '');
        this.button.disabled = true;
        this.button.textContent = this.loadingText;

        try {
          const response = await fetch(url);
          const text = await response.text();
          const newPageHTML = new DOMParser().parseFromString(text, 'text/html');
          const newItems = newPageHTML.querySelector(this.containerSelector);
          const newNextPageLink = newPageHTML.querySelector(this.nextPageLinkSelector);
          const currentContainer = document.querySelector(this.containerSelector);

          if (newItems && newItems.children.length > 0) {
            currentContainer.innerHTML += newItems.innerHTML;
            this.nextPageLink.href = newNextPageLink.href;
          }

          this.button.disabled = false;
          this.button.textContent = this.loadMoreText;
        } catch (error) {
          console.error('Error loading more products:', error);
          this.button.disabled = false;
          this.button.textContent = this.loadMoreText;
        } finally {
          this.removeAttribute('loading');
          this.updateButtonVisibility();
        }
      }
    },
  );
}
